export default __webpack_public_path__ + "ed3849ebe8fb1729ff9a3365e6df051f.webp";